/* eslint no-param-reassign: "off" */
import moment from 'moment';
import { getTomorrow } from '../utils/utils';

export default {
  install: (
    Vue, settings, lang, isSpa, isAuth, fullwidth, position, title, theme, from, to, daysFromNow, additionalSearch,
    searchBack, searchChanges, searchCurrency, spaAuth, sortType, sortField, urlLang, newTab, defaultPoints,
  ) => {
    Vue.prototype.$frameparams = settings;
    Vue.prototype.$framelocale = lang;
    Vue.prototype.$framespa = isSpa === '1';
    Vue.prototype.$frameauth = isAuth === '1';
    Vue.prototype.$fullwidth = fullwidth === '1';
    Vue.prototype.$position = position;
    Vue.prototype.$isSpaAuth = spaAuth === '1';
    Vue.prototype.$authTitle = title;
    Vue.prototype.$theme = theme;
    Vue.prototype.$UrlLang = urlLang;
    Vue.prototype.$hideAdditionalSearch = additionalSearch === '0';
    Vue.prototype.$searchBack = searchBack === '1';
    Vue.prototype.$searchChanges = searchChanges === '1';
    Vue.prototype.$searchCurrency = searchCurrency === '1';
    Vue.prototype.$newTab = newTab === '1';
    Vue.prototype.$defaultPoints = defaultPoints === '1';
    Vue.prototype.$sorting = {
      type: sortType,
      field: sortField,
    };

    if (from && to) {
      Vue.prototype.$search = {
        from,
        to,
        when: (daysFromNow >= 0) ? new Date(moment().add(daysFromNow, 'd').format('YYYY-MM-DD')) : getTomorrow(),
      };
    }
  },
};



// WEBPACK FOOTER //
// ./src/plugin/global.js